// extracted by mini-css-extract-plugin
export var attachment = "_lc-a";
export var emailContainer = "_lc-4";
export var emailContentPaddedContainer = "_lc-b";
export var emailHeader = "_lc-6";
export var emailIframe = "_lc-3";
export var emailInfoIcon = "_lc-9";
export var emailShortenedSummary = "_lc-e";
export var infoDropdown = "_lc-0";
export var infoRowBoundedContent = "_lc-d";
export var internal = "_lc-5";
export var merchant = "_lc-8";
export var messageInputContainer = "_lc-h";
export var normal = "_lc-7";
export var replyCard = "_lc-f";
export var subtleButton = "_lc-1";
export var subtleButtonIconContainer = "_lc-2";
export var toggleViewRepliesButton = "_lc-c";
export var wrappingText = "_lc-g";